import http from '@core/fetch'

export default {
  // 获取数据
  get_data: () => http(`/p/wedding/index.php/Admin/APIMerchant/upgrade_apply`),

  //添加/编辑
  edit: params =>
    http.post(`/p/wedding/index.php/Admin/APIMerchant/upgrade_apply`, {
      body: params,
      method: 'POST'
    }),

  // 获取状态,判断是否升级
  get_status: () =>
    http(`/p/wedding/index.php/Admin/APIMerchant/upgrade_status`),
  //
  openTrade: body =>
    http.post('/p/wedding/index.php/admin/APIMerchantBank/AppBindBank', {
      body
    }),

  checkVerifyStatusApi: body =>
    http('/p/wedding/Admin/APIMerchant/phoneEditStatus', { body }) //修改手机号码的进程
}
